import React, { useState, useEffect } from 'react';
import PaginationDropdown from "../PaginationDropdown/PaginationDropdown";

const Pagination = ({valuePagination, pagePagination, setPagePagination, setValuePagination, pageItem}) => {
  const [isOpenRowsPage, setIsOpenRowsPage] = useState(false);
  const [isOpenPage, setIsOpenPage] = useState(false);
  pageItem = pageItem || 1

  // Clamp to the LAST page when pageItem (total pages) shrinks below the current page —
  // e.g. a rows-per-page or filter change reduced the page count. Clamping (instead of
  // resetting to 1) keeps the operator as close as possible to where they were.
  useEffect(() => {
    const maxPage = typeof pageItem === 'number'
      ? pageItem
      : (parseInt(pageItem, 10) || 1);

    if (maxPage > 0 && pagePagination > maxPage) {
      setPagePagination(maxPage);
    }
  }, [pageItem, pagePagination, setPagePagination]);

  return (
    <div className="text-md flex items-center">
      <div className="flex items-center">
        <PaginationDropdown variant="standard" value={valuePagination} menuItems={['10', '25', '50', '100']}
                            setIsOpen={setIsOpenRowsPage} isOpen={isOpenRowsPage} label="Rows per page"
                            setValue={setValuePagination} className="mr-8" type="Rows"/>
        <PaginationDropdown variant="standard" value={pagePagination} menuItems={pageItem} setIsOpen={setIsOpenPage}
                            isOpen={isOpenPage} label="Page" setValue={setPagePagination} type="Page"/>
      </div>
    </div>
  );
};

export default Pagination;
